

// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import 'slick-carousel';

import header from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

$(function () {

    header();

    $('.parallax-video').jarallax();

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    $('.podcasts-element .podcasts-slider').slick({
        autoplay: false,
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: $('.podcasts-controls-prev'),
        nextArrow: $('.podcasts-controls-next'),
        responsive: [
            // {
            //     breakpoint: 1200,
            //     settings: {
            //         slidesToShow: 3,
            //         slidesToScroll: 3
            //     }
            // },
            // {
            //     breakpoint: 1024,
            //     settings: {
            //         slidesToShow: 3,
            //         slidesToScroll: 3
            //     }
            // },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

});


function detectIE() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}



$('.team-member').on('click', function(){
    var teamtitle = $(this).attr('data-attr-name');
    var teamposition = $(this).attr('data-attr-position');
    var teamcontent = $(this).attr('data-attr-content');
    console.log(teamtitle);

    $('.team-modal .team-member-title').html(teamtitle);
    $('.team-modal .team-member-position').html(teamposition);
    $('.team-modal .team-member-content').html(teamcontent);
});
